// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICategoryDto } from './ICategoryDto';
import {
    ICategoryDtoFromJSON,
    ICategoryDtoFromJSONTyped,
    ICategoryDtoToJSON,
    ICategoryDtoToJSONTyped,
} from './ICategoryDto';
import type { ICovTableDto } from './ICovTableDto';
import {
    ICovTableDtoFromJSON,
    ICovTableDtoFromJSONTyped,
    ICovTableDtoToJSON,
    ICovTableDtoToJSONTyped,
} from './ICovTableDto';
import type { IMpTableDto } from './IMpTableDto';
import {
    IMpTableDtoFromJSON,
    IMpTableDtoFromJSONTyped,
    IMpTableDtoToJSON,
    IMpTableDtoToJSONTyped,
} from './IMpTableDto';
import type { IAllowedServiceDto } from './IAllowedServiceDto';
import {
    IAllowedServiceDtoFromJSON,
    IAllowedServiceDtoFromJSONTyped,
    IAllowedServiceDtoToJSON,
    IAllowedServiceDtoToJSONTyped,
} from './IAllowedServiceDto';

/**
 * 
 * @export
 * @interface IPayoutDefinitionDto
 */
export interface IPayoutDefinitionDto {
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionDto
     */
    mp_table_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionDto
     */
    cov_table_id?: number;
    /**
     * 
     * @type {IMpTableDto}
     * @memberof IPayoutDefinitionDto
     */
    mp_table?: IMpTableDto;
    /**
     * 
     * @type {ICovTableDto}
     * @memberof IPayoutDefinitionDto
     */
    cov_table?: ICovTableDto;
    /**
     * 
     * @type {Array<IAllowedServiceDto>}
     * @memberof IPayoutDefinitionDto
     */
    allowed_services?: Array<IAllowedServiceDto>;
    /**
     * 
     * @type {number}
     * @memberof IPayoutDefinitionDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionDto
     */
    organization_path?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayoutDefinitionDto
     */
    organization_type?: IPayoutDefinitionDtoOrganizationTypeEnum;
    /**
     * 
     * @type {Array<ICategoryDto>}
     * @memberof IPayoutDefinitionDto
     */
    categories?: Array<ICategoryDto>;
    /**
     * 
     * @type {boolean}
     * @memberof IPayoutDefinitionDto
     */
    is_limited_use?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPayoutDefinitionDto
     */
    can_be_limited?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPayoutDefinitionDtoOrganizationTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}


/**
 * Check if a given object implements the IPayoutDefinitionDto interface.
 */
export function instanceOfIPayoutDefinitionDto(value: object): value is IPayoutDefinitionDto {
    return true;
}

export function IPayoutDefinitionDtoFromJSON(json: any): IPayoutDefinitionDto {
    return IPayoutDefinitionDtoFromJSONTyped(json, false);
}

export function IPayoutDefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayoutDefinitionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'mp_table_id': json['mp_table_id'] == null ? undefined : json['mp_table_id'],
        'cov_table_id': json['cov_table_id'] == null ? undefined : json['cov_table_id'],
        'mp_table': json['mp_table'] == null ? undefined : IMpTableDtoFromJSON(json['mp_table']),
        'cov_table': json['cov_table'] == null ? undefined : ICovTableDtoFromJSON(json['cov_table']),
        'allowed_services': json['allowed_services'] == null ? undefined : ((json['allowed_services'] as Array<any>).map(IAllowedServiceDtoFromJSON)),
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'organization_type': json['organization_type'] == null ? undefined : json['organization_type'],
        'categories': json['categories'] == null ? undefined : ((json['categories'] as Array<any>).map(ICategoryDtoFromJSON)),
        'is_limited_use': json['is_limited_use'] == null ? undefined : json['is_limited_use'],
        'can_be_limited': json['can_be_limited'] == null ? undefined : json['can_be_limited'],
    };
}

export function IPayoutDefinitionDtoToJSON(json: any): IPayoutDefinitionDto {
    return IPayoutDefinitionDtoToJSONTyped(json, false);
}

export function IPayoutDefinitionDtoToJSONTyped(value?: IPayoutDefinitionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'mp_table_id': value['mp_table_id'],
        'cov_table_id': value['cov_table_id'],
        'mp_table': IMpTableDtoToJSON(value['mp_table']),
        'cov_table': ICovTableDtoToJSON(value['cov_table']),
        'allowed_services': value['allowed_services'] == null ? undefined : ((value['allowed_services'] as Array<any>).map(IAllowedServiceDtoToJSON)),
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'organization_type': value['organization_type'],
        'categories': value['categories'] == null ? undefined : ((value['categories'] as Array<any>).map(ICategoryDtoToJSON)),
        'is_limited_use': value['is_limited_use'],
        'can_be_limited': value['can_be_limited'],
    };
}

